// @ts-strict-ignore
import { map } from 'rxjs/operators';
import { WagoApiClient } from '@shared/service/wago-api.client';
import { ModelConversionService } from '@shared/convert/model-conversion.service';
import { NumberUtils } from '@shared/util/number-utils';
import { ArticleNumberMappingListVO, ArticleNumberMappingUserDTO } from '../model/vo/article-number-mapping.vo';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ArticleNumberMappingService {
  private readonly loadMappingsByUserIdUrl: string = 'article-number-mapping/search';
  private readonly saveMappingUrl: string = 'article-number-mapping';

  constructor(private modelConversionService: ModelConversionService, private wagoApiClient: WagoApiClient) { }

  public loadMappingListsByUserId(userId: number): Observable<ArticleNumberMappingListVO[]> {
    if (NumberUtils.isNotNumber(userId)) {
      return of(null);
    }
    return this.wagoApiClient.get(`${this.loadMappingsByUserIdUrl}?userId=${userId}`)
      .pipe(
        map((data: any) => this.modelConversionService.convertArticleNumberMappingListVOs(data)));
  }

  public saveUserMappingLists(userId: number, articleNumberMappingLists: ArticleNumberMappingListVO[]): void {
    const dto: ArticleNumberMappingUserDTO = new ArticleNumberMappingUserDTO();
    dto.userId = userId;
    dto.articleNumberMappingLists = articleNumberMappingLists;
    this.wagoApiClient.post(this.saveMappingUrl, dto).pipe(map((response) => response)).subscribe(() => {
    });
  }
}
